import { render } from "./PaymentPositionToVendor.vue?vue&type=template&id=567e1abc&scoped=true"
import script from "./PaymentPositionToVendor.vue?vue&type=script&lang=js"
export * from "./PaymentPositionToVendor.vue?vue&type=script&lang=js"

import "./PaymentPositionToVendor.vue?vue&type=style&index=0&id=567e1abc&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567e1abc"]])

export default __exports__